import { MdSearch } from 'react-icons/md'

// Add custom styles for dark mode inputs
const darkModeStyles = `
  .dark input {
    background-color: #1f2937 !important;
    color: #ffffff !important;
  }
  .dark input::placeholder {
    color: #9ca3af !important;
  }
`

function SearchBar({ searchTerm, onSearchChange, placeholder = 'Search...', className = '' }) {
  return (
    <div className={`flex-1 max-w-md ${className}`}>
      {/* Add custom styles for dark mode */}
      <style>{darkModeStyles}</style>

      <div className="relative">
        <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-400 text-lg" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={onSearchChange}
          className="w-full pl-10 pr-4 py-2 border border-neutral-300 dark:border-neutral-600 rounded-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white placeholder-neutral-500 dark:placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  )
}

export default SearchBar
